// Iter 37 — Provider Reports.
// Thin wrapper that hard-pins the shared Reports engine to the
// "provider" lens. The actual rendering, filters, and trend logic
// all live in `Reports.jsx`. By mounting at /reports with
// lockedLens="provider", we get a "My Reports" page scoped to the
// signed-in provider's caseload — no school-wide cards, no lens
// toggle.
import Reports from "@/pages/Reports";

export default function ProviderReports() {
  return <Reports lockedLens="provider" />;
}
